module.exports = __webpack_public_path__ + "static/media/002-Desinfizieren_ID_1.9b930c5e.mp3";